<app-common-section-settings [section]="section" [gallery]="gallery" [theme]="theme">
  <h3 class="menu-list-title">MEDIA</h3>
  <div class="section-setting-row">
    <div class="setting-name">Grid</div>
    <div class="setting-value">
      @for (layout of assetSectionValues.layouts; track layout) {
        <button
          appButton
          [name]="'layout_' + layout"
          location="assets-section-menu"
          [color]="
            (section.grid_layout ?? theme.section.grid_layout) === layout ? 'simple-primary-opacity' : 'simple-gray-50'
          "
          [class.constant]="(section.grid_layout ?? theme.section.grid_layout) === layout"
          (click)="section.grid_layout = layout; updateLayout()"
          shape="round"
          height="0-5"
          spacing="1"
        >
          <app-svg src="/assets/icons/layout-{{ layout }}.svg"></app-svg>
        </button>
      }
    </div>
  </div>

  <div class="section-setting-row">
    <div class="setting-name">Size</div>
    <div class="setting-value">
      <div class="slider">
        <input
          type="range"
          [ngModel]="section.display_size ?? theme.section.display_size"
          [min]="25"
          [max]="65"
          (ngModelChange)="updateAssetSize($event)"
        />
        <label></label>
      </div>
    </div>
  </div>

  <div class="section-setting-row">
    <div class="setting-name">Spacing</div>
    <div class="setting-value">
      <div class="slider">
        <input
          type="range"
          [ngModel]="section.spacing ?? theme.section.spacing"
          [min]="0"
          [max]="50"
          (ngModelChange)="updateAssetSpacing($event)"
        />
        <label></label>
      </div>
    </div>
  </div>

  <div class="section-setting-row">
    <div class="setting-name">Filenames</div>
    <div class="setting-value">
      <app-switch [small]="true">
        <input
          type="checkbox"
          id="option-show-filenames"
          [ngModel]="section.show_filenames ?? theme.section.show_filenames"
          (ngModelChange)="updateShowFilenames($event)"
        />
        <label for="option-show-filenames" data-test-id="option-show-filenames"></label>
      </app-switch>
    </div>
  </div>

  <div class="section-setting-row">
    <div class="setting-name">Rounded</div>
    <div class="setting-value">
      <app-switch [small]="true">
        <input
          type="checkbox"
          id="option-rounded-corners"
          [ngModel]="section.rounded_corners ?? theme.section.rounded_corners"
          (ngModelChange)="updateRoundedCorners($event)"
        />
        <label for="option-rounded-corners" data-test-id="option-rounded-corners"></label>
      </app-switch>
    </div>
  </div>

  <div class="divider"></div>
</app-common-section-settings>
